import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { defineMessage } from 'react-intl';
import { DownloadBtns } from './DownloadBtns';

const mediaFilesTitleMessage = defineMessage({
  id: 'fragments.mediaStatus.title',
  defaultMessage: 'Archivos de media',
});

/**
 * Media download section on the Files tab: video/audio download actions under a field-group header.
 */
export function FragmentMediaFiles() {
  return (
    <ContentCluster message={mediaFilesTitleMessage} divider={false}>
      <DownloadBtns />
    </ContentCluster>
  );
}
